import React from 'react';

export default function StatusKerjaSiswa() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Status Kerja Siswa</h1>
      <p className="text-gray-500">Halaman Status Kerja Siswa</p>
    </div>
  );
}
